import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Menu, X, LogOut, User as UserIcon, LayoutDashboard, List, Truck, Archive, Users, PlusCircle } from 'lucide-react';
export function Navbar() {
  const {
    user,
    logout
  } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  if (!user) return null;
  const isActive = (path: string) => location.pathname === path;
  const getNavItems = () => {
    switch (user.role) {
      case 'ADMIN':
        return [{
          label: 'Tableau de bord',
          path: '/admin',
          icon: LayoutDashboard
        }, {
          label: 'Nouvelle Commande',
          path: '/orders/new',
          icon: PlusCircle
        }, {
          label: 'Commandes',
          path: '/orders',
          icon: List
        }, {
          label: 'Tournées',
          path: '/tours',
          icon: Truck
        }, {
          label: 'Utilisateurs',
          path: '/users',
          icon: Users
        }];
      case 'CHAUFFEUR':
        return [{
          label: 'Tableau de bord',
          path: '/driver',
          icon: LayoutDashboard
        }, {
          label: 'Mes Tournées',
          path: '/driver/tours',
          icon: Truck
        }];
      case 'DEPOT':
        return [{
          label: 'Tableau de bord',
          path: '/depot',
          icon: LayoutDashboard
        }, {
          label: 'Réception',
          path: '/depot/reception',
          icon: Archive
        }, {
          label: 'Nettoyage',
          path: '/depot/cleaning',
          icon: List
        }, {
          label: 'Stockage',
          path: '/depot/storage',
          icon: Archive
        }];
      default:
        return [];
    }
  };
  const navItems = getNavItems();
  return <nav className="bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-117">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-118">
        <div className="flex justify-between h-16" data-id="element-119">
          <div className="flex" data-id="element-120">
            <div className="flex-shrink-0 flex items-center" data-id="element-121">
              <img className="h-10 w-auto" src="https://vipclean.tn/wp-content/uploads/2022/08/Nouveau-projetlogovipclean-150x150.png" alt="VIP Clean" data-id="element-122" />
              <span className="ml-2 text-lg font-bold text-gray-900 hidden sm:block" data-id="element-123">
                VIP CLEAN
              </span>
            </div>
            <div className="hidden sm:ml-6 sm:flex sm:space-x-8" data-id="element-124">
              {navItems.map(item => <Link key={item.path} to={item.path} className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium ${isActive(item.path) ? 'border-blue-500 text-gray-900' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'}`} data-id="element-125">
                  <item.icon className="w-4 h-4 mr-2" data-id="element-126" />
                  {item.label}
                </Link>)}
            </div>
          </div>

          <div className="hidden sm:ml-6 sm:flex sm:items-center" data-id="element-127">
            <div className="flex items-center space-x-4" data-id="element-128">
              <div className="flex items-center text-sm text-gray-700" data-id="element-129">
                <UserIcon className="w-4 h-4 mr-2" data-id="element-130" />
                <span data-id="element-131">
                  {user.name} ({user.role})
                </span>
              </div>
              <button onClick={logout} className="p-2 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none" title="Déconnexion" data-id="element-132">
                <LogOut className="w-5 h-5" data-id="element-133" />
              </button>
            </div>
          </div>

          <div className="-mr-2 flex items-center sm:hidden" data-id="element-134">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500" data-id="element-135">
              <span className="sr-only" data-id="element-136">Open main menu</span>
              {isMenuOpen ? <X className="block h-6 w-6" aria-hidden="true" data-id="element-137" /> : <Menu className="block h-6 w-6" aria-hidden="true" data-id="element-138" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && <div className="sm:hidden bg-white border-b border-gray-200 shadow-lg absolute w-full" data-id="element-139">
          <div className="pt-2 pb-3 space-y-1" data-id="element-140">
            {navItems.map(item => <Link key={item.path} to={item.path} onClick={() => setIsMenuOpen(false)} className={`block pl-3 pr-4 py-2 border-l-4 text-base font-medium ${isActive(item.path) ? 'bg-blue-50 border-blue-500 text-blue-700' : 'border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700'}`} data-id="element-141">
                <div className="flex items-center" data-id="element-142">
                  <item.icon className="w-5 h-5 mr-3" data-id="element-143" />
                  {item.label}
                </div>
              </Link>)}
          </div>
          <div className="pt-4 pb-4 border-t border-gray-200" data-id="element-144">
            <div className="flex items-center px-4" data-id="element-145">
              <div className="flex-shrink-0" data-id="element-146">
                <div className="h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center" data-id="element-147">
                  <UserIcon className="h-6 w-6 text-gray-500" data-id="element-148" />
                </div>
              </div>
              <div className="ml-3" data-id="element-149">
                <div className="text-base font-medium text-gray-800" data-id="element-150">
                  {user.name}
                </div>
                <div className="text-sm font-medium text-gray-500" data-id="element-151">
                  {user.email}
                </div>
              </div>
              <button onClick={logout} className="ml-auto flex-shrink-0 p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none" data-id="element-152">
                <LogOut className="h-6 w-6" data-id="element-153" />
              </button>
            </div>
          </div>
        </div>}
    </nav>;
}